import { getTelegramWebApp, isTMAIOS } from '@web/libs/tg/platform'

// Единый источник высоты клавиатуры на web (visualViewport). Порог отсекает сжатие от
// тулбара браузера / пинча — клавиатура всегда заметно выше.
const KEYBOARD_MIN_HEIGHT = 150

let inset = 0
const listeners = new Set<() => void>()
let installed = false

// iOS TMA — единственный проблемный кейс: в WKWebView Telegram `visualViewport`/
// `window.innerHeight` считают высоту клавиатуры неверно (innerHeight включает
// область вне вьюпорта), из-за чего sticky-футер уезжал на середину экрана.
// Android (браузер/TMA) и iOS-браузер с формулой ниже работают корректно —
// поэтому их НЕ трогаем. Для iOS TMA берём родные размеры Telegram:
// viewportStableHeight (без клавиатуры) − viewportHeight (с клавиатурой).
function readTmaIosKeyboardInset(): number | null {
  const webApp = getTelegramWebApp()

  if (!webApp || webApp.viewportHeight === undefined || webApp.viewportStableHeight === undefined) {
    return null
  }

  const raw = Math.max(0, webApp.viewportStableHeight - webApp.viewportHeight)
  return raw >= KEYBOARD_MIN_HEIGHT ? raw : 0
}

export function readWebKeyboardInset(): number {
  if (typeof window === 'undefined') return 0

  if (isTMAIOS()) {
    const tmaInset = readTmaIosKeyboardInset()

    if (tmaInset !== null) return tmaInset
  }

  const vv = window.visualViewport

  if (!vv) return 0

  const raw = Math.max(0, window.innerHeight - vv.offsetTop - vv.height)
  return raw >= KEYBOARD_MIN_HEIGHT ? raw : 0
}

function sync() {
  const next = readWebKeyboardInset()

  if (next === inset) return
  inset = next
  listeners.forEach((listener) => {
    listener()
  })
}

function install() {
  if (installed || typeof window === 'undefined') return
  installed = true
  sync()
  window.visualViewport?.addEventListener('resize', sync)
  window.visualViewport?.addEventListener('scroll', sync)
  // В iOS TMA клавиатура меняет только Telegram-вьюпорт — visualViewport-события
  // могут не сработать, поэтому слушаем ещё и родное событие Telegram.
  getTelegramWebApp()?.onEvent('viewportChanged', sync)
}

export function subscribeWebKeyboardInset(onStoreChange: () => void): () => void {
  install()
  listeners.add(onStoreChange)
  return () => listeners.delete(onStoreChange)
}

export function getWebKeyboardInset(): number {
  install()
  return inset
}
